export const countryCodes = [
  { name: 'Afganistan', code: '+93', iso: 'af' },
  { name: 'Almanya', code: '+49', iso: 'de' },
  { name: 'Amerika Birleşik Devletleri', code: '+1', iso: 'us' },
  { name: 'Andorra', code: '+376', iso: 'ad' },
  { name: 'Angola', code: '+244', iso: 'ao' },
  { name: 'Arjantin', code: '+54', iso: 'ar' },
  { name: 'Avustralya', code: '+61', iso: 'au' },
  { name: 'Avusturya', code: '+43', iso: 'at' },
  { name: 'Azerbaycan', code: '+994', iso: 'az' },
  { name: 'Bahreyn', code: '+973', iso: 'bh' },
  { name: 'Bangladeş', code: '+880', iso: 'bd' },
  { name: 'Belçika', code: '+32', iso: 'be' },
  { name: 'Birleşik Arap Emirlikleri', code: '+971', iso: 'ae' },
  { name: 'Birleşik Krallık', code: '+44', iso: 'gb' },
  { name: 'Brezilya', code: '+55', iso: 'br' },
  { name: 'Bulgaristan', code: '+359', iso: 'bg' },
  { name: 'Çekya', code: '+420', iso: 'cz' },
  { name: 'Çin', code: '+86', iso: 'cn' },
  { name: 'Danimarka', code: '+45', iso: 'dk' },
  { name: 'Endonezya', code: '+62', iso: 'id' },
  { name: 'Ermenistan', code: '+374', iso: 'am' },
  { name: 'Estonya', code: '+372', iso: 'ee' },
  { name: 'Fas', code: '+212', iso: 'ma' },
  { name: 'Fiji', code: '+679', iso: 'fj' },
  { name: 'Finlandiya', code: '+358', iso: 'fi' },
  { name: 'Fransa', code: '+33', iso: 'fr' },
  { name: 'Güney Afrika', code: '+27', iso: 'za' },
  { name: 'Güney Kore', code: '+82', iso: 'kr' },
  { name: 'Gürcistan', code: '+995', iso: 'ge' },
  { name: 'Hindistan', code: '+91', iso: 'in' },
  { name: 'Hollanda', code: '+31', iso: 'nl' },
  { name: 'Irak', code: '+964', iso: 'iq' },
  { name: 'İran', code: '+98', iso: 'ir' },
  { name: 'İrlanda', code: '+353', iso: 'ie' },
  { name: 'İspanya', code: '+34', iso: 'es' },
  { name: 'İsrail', code: '+972', iso: 'il' },
  { name: 'İsveç', code: '+46', iso: 'se' },
  { name: 'İsviçre', code: '+41', iso: 'ch' },
  { name: 'İtalya', code: '+39', iso: 'it' },
  { name: 'İzlanda', code: '+354', iso: 'is' },
  { name: 'Japonya', code: '+81', iso: 'jp' },
  { name: 'Kanada', code: '+1', iso: 'ca' },
  { name: 'Katar', code: '+974', iso: 'qa' },
  { name: 'Kazakistan', code: '+7', iso: 'kz' },
  { name: 'Kenya', code: '+254', iso: 'ke' },
  { name: 'Kırgızistan', code: '+996', iso: 'kg' },
  { name: 'Kıbrıs', code: '+357', iso: 'cy' },
  { name: 'Kolombiya', code: '+57', iso: 'co' },
  { name: 'Kuveyt', code: '+965', iso: 'kw' },
  { name: 'Letonya', code: '+371', iso: 'lv' },
  { name: 'Libya', code: '+218', iso: 'ly' },
  { name: 'Litvanya', code: '+370', iso: 'lt' },
  { name: 'Lübnan', code: '+961', iso: 'lb' },
  { name: 'Lüksemburg', code: '+352', iso: 'lu' },
  { name: 'Macaristan', code: '+36', iso: 'hu' },
  { name: 'Makedonya', code: '+389', iso: 'mk' },
  { name: 'Malezya', code: '+60', iso: 'my' },
  { name: 'Meksika', code: '+52', iso: 'mx' },
  { name: 'Mısır', code: '+20', iso: 'eg' },
  { name: 'Moldova', code: '+373', iso: 'md' },
  { name: 'Nepal', code: '+977', iso: 'np' },
  { name: 'Nijerya', code: '+234', iso: 'ng' },
  { name: 'Norveç', code: '+47', iso: 'no' },
  { name: 'Özbekistan', code: '+998', iso: 'uz' },
  { name: 'Pakistan', code: '+92', iso: 'pk' },
  { name: 'Peru', code: '+51', iso: 'pe' },
  { name: 'Polonya', code: '+48', iso: 'pl' },
  { name: 'Portekiz', code: '+351', iso: 'pt' },
  { name: 'Romanya', code: '+40', iso: 'ro' },
  { name: 'Rusya', code: '+7', iso: 'ru' },
  { name: 'Sırbistan', code: '+381', iso: 'rs' },
  { name: 'Singapur', code: '+65', iso: 'sg' },
  { name: 'Slovakya', code: '+421', iso: 'sk' },
  { name: 'Slovenya', code: '+386', iso: 'si' },
  { name: 'Sri Lanka', code: '+94', iso: 'lk' },
  { name: 'Suudi Arabistan', code: '+966', iso: 'sa' },
  { name: 'Şili', code: '+56', iso: 'cl' },
  { name: 'Tacikistan', code: '+992', iso: 'tj' },
  { name: 'Tayland', code: '+66', iso: 'th' },
  { name: 'Tunus', code: '+216', iso: 'tn' },
  { name: 'Türkiye', code: '+90', iso: 'tr' },
  { name: 'Türkmenistan', code: '+993', iso: 'tm' },
  { name: 'Ukrayna', code: '+380', iso: 'ua' },
  { name: 'Umman', code: '+968', iso: 'om' },
  { name: 'Ürdün', code: '+962', iso: 'jo' },
  { name: 'Venezuela', code: '+58', iso: 've' },
  { name: 'Vietnam', code: '+84', iso: 'vn' },
  { name: 'Yeni Zelanda', code: '+64', iso: 'nz' },
  { name: 'Yunanistan', code: '+30', iso: 'gr' },
  { name: 'Zambiya', code: '+260', iso: 'zm' }
];
